import ConsultSection from "../PageElements/HomePageElements/ConsultSection";
import PrivacyPolicyMainSection from "../PageElements/PrivacyPolicyPageElement/PrivacyPolicyMainSection";


export default function PrivacyPolicy() {
    return (
        <>

            <PrivacyPolicyMainSection/>
            <ConsultSection/>
            
        </>
    )
}